import React from "react";
import ConfirmDialog from "../../components/ConfirmDialog";
import { scrollToTop } from "../../services";
import ReactGA from "react-ga4";
export const NoImagesModal = ({
  isNoImagesModalShown,
  isValidating, setIsAdWithoutImages,
  setIsNoImagesModalShown,
  handleSubmitProceeded
}) => {
  return (
    <ConfirmDialog
      visible={isNoImagesModalShown}
      title={null}
      className={null}
      close={() => { }}
      cancelButtonProps={{
        disabled: isValidating
      }}
      onOk={() => {
        ReactGA.event({
          category: "form warning",
          action: "click",
          label: "Klik - Učitaj slike"
        });
        setIsNoImagesModalShown(false)

        setTimeout(() => {
          scrollToTop();
        }, 100);
      }}
      onCancel={() => {
        ReactGA.event({
          category: "form warning",
          action: "click",
          label: "Klik - Nastavi bez slika"
        });
        setIsNoImagesModalShown(false);
        setIsAdWithoutImages(true)
        handleSubmitProceeded();
      }}
      okText="Učitaj slike"
      cancelText="Nastavi bez slika"
    >
      <p>{"Oglasi bez slika ostvaruju znatno manje pregleda. Molimo vas dodajte slike kako bi vaš oglas privukao više pažnje."}</p>
    </ConfirmDialog>

  )
}


// WEBPACK FOOTER //
// ./src/containers/AdFormPage/NoImagesModal.tsx